import type { RefObject } from 'react';
import type { ModernCreativityInfoItemRef } from './modern-creativity-info-item/ModernCreativityInfoItem.data';
import { findTransitionController } from '../../../util/core-transition-component';
import type { LottieViewRef } from '../../atoms/lottie-view/LottieView.data';
import { fadeFromTo } from '../../../util/animation/fade/fade';

interface ModernCreativityInfoRefs {
  elementRef?: RefObject<HTMLElement | null>;
  lottieRef?: RefObject<LottieViewRef | null>;
  itemsRef?: RefObject<Array<RefObject<ModernCreativityInfoItemRef | null>> | null>;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  { lottieRef, itemsRef }: ModernCreativityInfoRefs,
): void {
  const lottieAnimation = {
    progress: 0,
  };

  const endFrame = 206;
  const symbol1Animation = 74 / endFrame;
  const symbol2Animation = 156 / endFrame;
  const symbol3Animation = 1;

  if (lottieRef?.current?.elementRef?.current) {
    timeline.add(fadeFromTo(lottieRef.current.elementRef.current, { duration: 0.1 }), 0);

    timeline.fromTo(
      lottieAnimation,
      { progress: 0 },
      {
        progress: symbol1Animation,
        ease: 'none',
        duration: 0.33,
        onUpdate: () => {
          lottieRef?.current?.setProgress(lottieAnimation.progress);
        },
      },
      0,
    );

    timeline.fromTo(
      lottieAnimation,
      { progress: symbol1Animation },
      {
        progress: symbol2Animation,
        ease: 'none',
        duration: 0.33,
        onUpdate: () => {
          lottieRef?.current?.setProgress(lottieAnimation.progress);
        },
      },
      0.33,
    );

    timeline.fromTo(
      lottieAnimation,
      { progress: symbol2Animation },
      {
        progress: symbol3Animation,
        ease: 'none',
        duration: 0.25,
        onUpdate: () => {
          lottieRef?.current?.setProgress(lottieAnimation.progress);
        },
      },
      0.66,
    );
  }

  if (itemsRef) {
    itemsRef?.current?.forEach((item, index) => {
      if (window.innerWidth < 1024) {
        // || index < 2
        timeline.fromTo(
          item.current,
          { y: 0 },
          { y: -100, duration: 0.4, ease: 'Power2.easeIn' },
          index * 0.33,
        );
      }
    });
  }
}

export function setupSlidesTimeline(
  timeline: gsap.core.Timeline,
  { itemsRef }: ModernCreativityInfoRefs,
): void {
  timeline.addLabel(`slide_-1`);

  if (itemsRef) {
    itemsRef?.current?.forEach((item, index) => {
      const buttonController = findTransitionController(item);
      if (buttonController) {
        timeline.add(buttonController.getTimeline('in') as gsap.core.Timeline, '>');
        timeline.addLabel(`slide_${index}`);
        timeline.add(buttonController.getTimeline('out') as gsap.core.Timeline, '>');
      }
    });
  }
}

// in (0) ( reverse in -> to hide)
// out (0) ( resverse out -> to show)
// in (1)
// out (1)
// in (2)
// out (2)

// in (2)
// out(2)
// in (1)
// out (1)
// in (0)
// out (0)
//
// export function setupSlidesOutTimeline(
//   timeline: gsap.core.Timeline,
//   { itemsRef }: ModernCreativityInfoRefs,
// ): void {
//
//   timeline.addLabel('start');
//   if (itemsRef) {
//     const length = itemsRef.length - 1;
//
//     itemsRef.forEach((item, index) => {
//       const buttonController = findTransitionController(itemsRef[length - index]);
//       if (buttonController) {
//         timeline.add(buttonController.getTimeline('in') as gsap.core.Timeline, '>');
//         timeline.addLabel(`slide_${length - index}`);
//         timeline.add(buttonController.getTimeline('out') as gsap.core.Timeline, '>');
//       }
//     });
//   }
//
//   timeline.addLabel(`slide_-1`);
//   timeline.addLabel('end');
// }
